export var TimeFrameOptions;
(function (TimeFrameOptions) {
    TimeFrameOptions[TimeFrameOptions["LAST_1_HOUR"] = 1] = "LAST_1_HOUR";
    TimeFrameOptions[TimeFrameOptions["LAST_3_HOURS"] = 3] = "LAST_3_HOURS";
    TimeFrameOptions[TimeFrameOptions["LAST_6_HOURS"] = 6] = "LAST_6_HOURS";
    TimeFrameOptions[TimeFrameOptions["LAST_9_HOURS"] = 9] = "LAST_9_HOURS";
    TimeFrameOptions[TimeFrameOptions["LAST_12_HOURS"] = 12] = "LAST_12_HOURS";
    TimeFrameOptions[TimeFrameOptions["LAST_24_HOURS"] = 24] = "LAST_24_HOURS";
})(TimeFrameOptions || (TimeFrameOptions = {}));
//# sourceMappingURL=index.js.map